// extracted by mini-css-extract-plugin
module.exports = {"brightCoveContainer":"Riddle_brightCoveContainer__2FFST","brightCoveVideo":"Riddle_brightCoveVideo__Ah0BI"};